import icons from '@/assets/icons';

export function WarningIcon() {
  return (
    <div className="flex size-8 items-center justify-center rounded-md bg-[#f5e695]">
      <img src={icons['alert-01']} alt="Warning" className="h-5 w-5" />
    </div>
  );
}
